import { loadAdminPreferences } from "@/lib/adminSettings";
import type { PeriodPreset } from "@/hooks/usePeriodFilter";

const periodValues = new Set<PeriodPreset>([
  "today",
  "yesterday",
  "7d",
  "14d",
  "30d",
  "90d",
  "6m",
  "1y",
  "all",
  "custom",
]);

export interface UsersSearch {
  period: PeriodPreset;
  from?: string;
  to?: string;
  createdFrom?: string;
  createdTo?: string;
  segment?: string;
  cluster?: string;
  cohortMonth?: string;
}

export function validateUsersSearch(search: Record<string, unknown>): UsersSearch {
  const period = typeof search.period === "string" && periodValues.has(search.period as PeriodPreset)
    ? (search.period as PeriodPreset)
    : loadAdminPreferences().defaultPeriod;

  const result: UsersSearch = { period };

  if (period === "custom") {
    if (typeof search.from === "string") result.from = search.from;
    if (typeof search.to === "string") result.to = search.to;
  }

  if (typeof search.createdFrom === "string") result.createdFrom = search.createdFrom;
  if (typeof search.createdTo === "string") result.createdTo = search.createdTo;
  if (typeof search.segment === "string") result.segment = search.segment;
  if (typeof search.cluster === "string") result.cluster = search.cluster;
  if (typeof search.cohortMonth === "string") result.cohortMonth = search.cohortMonth;

  return result;
}
